/**
* @ComponentFor Avensia.Shop.Features.AppShell.Partials.AppShell
*/
import React from 'react';
import Logotype from 'Shared/Logotype';
import Main, { Section } from 'Shared/PageLayout';
import { translate } from 'Shared/translate';
import * as styles from './base.scss';
// This component is rendered when the visitor has a service worker enabled browser
// and she is making a full page load for a url that we don't have in the local cache.
// So the app shell (header and footer) will be rendered and this component gets
// rendered during the time we load the page she wanted.
export default class AppShell extends React.Component {
    render() {
        return (React.createElement(Main, { appearance: "narrow", className: styles.base }, this.props.isLoading ? (React.createElement(Logotype, { className: styles.logo, siteUrl: "/" })) : this.props.loadFailure && this.props.loadFailure.status === 404 ? (React.createElement(Section, null,
            React.createElement("h1", null, translate('/Errors/PageNotFoundHeader')),
            React.createElement("p", null, translate('/Errors/PageNotFoundText')))) : !navigator.onLine ? (React.createElement(Section, null,
            React.createElement("h1", null, translate('/Errors/OfflineHeader')),
            React.createElement("p", null, translate('/Errors/OfflineText')))) : (React.createElement(Section, null,
            React.createElement("h1", null, translate('/Errors/UnknownLoadFailureHeader')),
            React.createElement("p", null, translate('/Errors/UnknownLoadFailureText'))))));
    }
}
